export const BUTTON = 'BUTTON';
export const BUTTON_DISABLED = 'BUTTON_DISABLED';
export const QUANTITY_INPUT = 'QUANTITY_INPUT';
